import React from "react";

export default function DashboardScreen() {
  const urlPBI = "https://app.powerbi.com/view?r=eyJrIjoiZDA2MDhiNmMtMDA5OC00YjQzLThhM2YtYzAyMWUzZWJkNWRkIiwidCI6ImIxNjFjODk3LTBhZTItNDJhMC1iZTg2LThmN2UzNmYyMDQ5ZiJ9"
  return (
    <div style={{ height: "700px", width: "100%" }}>
      <iframe
        src={urlPBI}
        title="Embedded Website"
        width="100%"
        height="100%"
        style={{ border: "none" }}
        allowFullScreen
      />
    </div>
  );
}
